export default __webpack_public_path__ + "static/edition-b05bbdca9697f22664a1ab88def36f5d.png";